import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CreateVideoCommentInputDto, VideoCommentDto } from "../../../models/video-review/dto/video-comment.dto";
import { GET_VIDEO_SUBMISSION_QUERY_KEY } from "./useGetVideoSubmission";

export const useAddVideoComment = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ submissionId, input }: { submissionId: string; input: CreateVideoCommentInputDto }) =>
            client.fetchApi<VideoCommentDto, CreateVideoCommentInputDto>({
                endpoint: `video-submissions/${submissionId}/comments`,
                method: 'POST',
                body: input,
            }),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: GET_VIDEO_SUBMISSION_QUERY_KEY(variables.submissionId) });
        },
    });
};
